import React, { Component } from 'react';
import config from '../../config';
import PropTypes from 'prop-types';
import * as queryString from 'query-string';
import trackCampaign from '../../utils/trackCampaign';
import { connect } from 'react-redux';
import { MobileNavigation, DesktopNavigation, BrandIcons } from 'components';
import en from '../../international/translations/en';
import brandToString from '../../utils/brandToString';

class Account extends Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    routeQuery: PropTypes.string,
    subscription: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    const subscriptionTitle = this.props.subscription.hasMultipleSubscriptions ? 'SUBSCRIPTIONS' : 'SUBSCRIPTION';
    this.accountChildRoutes = [
      { name: 'OVERVIEW', path: '/account/overview'},
      { name: 'EDIT PROFILE', path: '/account/edit-profile'},
      { name: 'CHANGE PASSWORD', path: '/account/change-password'},
      { name: subscriptionTitle, path: '/account/subscription'}
    ];
    if (config.company === 'sl') this.accountChildRoutes.splice( 2, 0, { name: 'FAVORITES', path: '/account/favorites'});
    if (config.company === 'sl') this.accountChildRoutes.splice(3, 0, { name: 'SETTINGS', path: '/account/edit-settings'});
  }

  componentDidMount() {
    if (window.analytics) {
      if (this.props.user && this.props.user._id) {
        window.analytics.identify(this.props.user._id);
      }
      const query = queryString.parse(location.search);
      if (query) {
        trackCampaign(query);
      }
    }
  }

  render() {
    return (
      <div>
        <div className="account-header__container">
          <div className="account-header__sub_container">
              <div className="account-header-go-back">
                <a className="account-header-go-back__link" href={en.account.header.go_back_link(this.props.referrer, brandToString())}>
                  {en.account.header.go_back_text(brandToString())}
                </a>
              </div>
              <BrandIcons theme="account" />
          </div>
        </div>
        <div className="account-subnavigation__container">
          <div className="account-subnavigation__container__list">
            <MobileNavigation childRoutes={this.accountChildRoutes} routing={this.props.routing} />
            <DesktopNavigation childRoutes={this.accountChildRoutes} />
          </div>
        </div>
        <div className="account-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    user: state.user,
    routing: state.routing,
    subscription: state.subscription,
    referrer: state.referrer,
  };
})(Account);
